import { Box, styled, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import PieChartComponent from "./chart/pieChart";

const CustomTabs = styled(Tabs)(({ theme }) => ({
  padding: "1rem",
  borderRight: "1px solid #e0e0e0",
  minWidth: "23%",
  zIndex:"0",
  "& .MuiTabs-indicator": {
    backgroundColor: "#054ef9",
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100% !important",
  },
}));

const CustomTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontSize: "0.9rem",
  color: "rgba(0, 0, 0, 0.54)",
  "&.Mui-selected": {
    color: "#054ef9", // Custom color for the active tab text
    backgroundColor: "#054ef956",
    border: "none",
    borderRadius: "5px",
  },
}));

function TabPanel(props) {
  const { children, value, index, width, ...other } = props;

  return (
    <div
      role="tabpanel"
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{
        display: value !== index ? "none" : "flex",
        alignItems: "center",
        justifyContent: "center",
        width: width ? width : "auto",
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1, display: "flex", alignItems: "center" }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const SuburbChart = ({ data, incomeData, languageData }) => {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const processIncomeData = (data) => {
    return data?.map((item) => parseFloat(item.income.replace("%", "")));
  };

  const processIncomeLabels = (data) => {
    return data?.map((item) => item.name);
  };

  const generateColorMap = (keys) => {
    const baseColor = "rgba(5,77,249,"; // Base color without opacity
    const opacityStep = 1 / keys.length; // Calculate the opacity step

    return keys.reduce((colorMap, key, index) => {
      const opacity = 1 - index * opacityStep;
      colorMap[key] = `${baseColor}${opacity.toFixed(2)})`;
      return colorMap;
    }, {});
  };

  const formatLanguageLabels = (labels) => {
    return labels.map((label) => label.replace(/_/g, " "));
  };

  const languageKeys = Object.keys(languageData);
  const formattedLanguageLabels = formatLanguageLabels(languageKeys);
  const languageColors = generateColorMap(formattedLanguageLabels);

  const incomeLabels = processIncomeLabels(incomeData);
  const incomeColors = generateColorMap(incomeLabels);
  
  return (
    <Box
      sx={(theme) => ({
        flexGrow: 1,
        bgcolor: "background.paper",
        display: "flex",
        height: 500,
        borderRadius: "10px",
        [theme.breakpoints.down("sm")]: {
          display: "flex",
          flexDirection: "column",
          height: "max-content",
        },
      })}
    >
      <CustomTabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
      >
        <CustomTab label="Single & Family" {...a11yProps(0)} />
        <CustomTab label="Owner & Renter" {...a11yProps(1)} />
        <CustomTab label="Income" {...a11yProps(2)} />
        <CustomTab label="Language Spoken at Home" {...a11yProps(3)} />
      </CustomTabs>
      <TabPanel value={value} index={0} width="100%">
        {data.family == null || data.family == 0 ? (
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "800px",
              height: "352px",
              fontSize: "1.12rem",
              [theme.breakpoints.down("sm")]: {
                width: "90vw",
                height: "10rem",
                mb: 1,
              },
            })}
          >
            No Data
          </Box>
        ) : (
          <Box sx={(theme) => ({  width: "36.5rem", marginTop: "-1rem", [theme.breakpoints.down("sm")]: { width: "21.5rem" } })}>
             <div className="family-chart">
            <PieChartComponent
              numbers={[Number(data?.family), Number(data?.single)]}
              labels={["Family", "Single"]}
              chartColors={{
                Family: "#054ef9eb",
                Single: "#054ef9a0",
              }}
            />
             </div>
          </Box>
        )}
      </TabPanel>
      <TabPanel value={value} index={1} width="100%">
        {data?.owner == null || data?.owner == 0 ? (
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "800px",
              height: "352px",
              fontSize: "1.12rem",
              [theme.breakpoints.down("sm")]: {
                width: "90vw",
                height: "10rem",
                mb: 1,
              },
            })}
          >
            No Data
          </Box>
        ) : (
          <Box sx={(theme) => ({  width: "36.5rem", marginTop: "-1rem", [theme.breakpoints.down("sm")]: { width: "21.5rem" } })}>
             <div className="owner-chart">
            <PieChartComponent
              numbers={[Number(data?.owner), Number(data?.renter)]}
              labels={["Owner", "Renter"]}
              chartColors={{
                Owner: "#054ef9eb",
                Renter: "#054ef9a0",
              }}
            />
             </div>
          </Box>
        )}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {incomeData[0].income === "No data" ? (
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "870px",
              height: "352px",
              fontSize: "1.12rem",
              [theme.breakpoints.down("sm")]: {
                width: "90vw",
                height: "10rem",
                mb: 1,
              },
            })}
          >
            No Data
          </Box>
        ) : (
          <Box sx={(theme) => ({  width: "36.5rem", marginTop: "-1rem", [theme.breakpoints.down("sm")]: { width: "21.5rem" } })}>
            <div className="income-chart">
            <PieChartComponent
              numbers={processIncomeData(incomeData)}
              labels={incomeLabels}
              chartColors={incomeColors}
            />
            </div>
          </Box>
        )}
      </TabPanel>
      <TabPanel value={value} index={3}>
        {Object.keys(languageData).length == 0 ? (
          <Box
            sx={(theme) => ({
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "870px",
              height: "352px",
              fontSize: "1.12rem",
              [theme.breakpoints.down("sm")]: {
                width: "90vw",
                height: "10rem",
                mb: 1,
              },
            })}
          >
            No Data
          </Box>
        ) : (
          <Box sx={(theme) => ({  width: "36.5rem", marginTop: "-1rem", [theme.breakpoints.down("sm")]: { width: "21.5rem" } })}>
            <div className="lang-chart">
            <PieChartComponent
              numbers={Object.values(languageData)}
              labels={formattedLanguageLabels}
              chartColors={languageColors}
            />
            </div>
          </Box>
        )}
      </TabPanel>
    </Box>
  );
};

export default SuburbChart;
